import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../_helpers/Api'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import { trans } from '../../../../_providers/Translation'
import loader from '../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function Others(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: null,
        loading: false,
        onSave: null
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        show: data => {
            setPopup(prev => ({
                ...prev,
                loading: false,
                data: data
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }))
        }
    }))


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'settings/edit'

        let data = new FormData(e.target)

        Api.post(url, data)
            .then(res => {

                handleHide(e)

                if (typeof popup.onSave === 'function') {
                    popup.onSave()
                }

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name.split('[')[1].replace(']', '')
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary small`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.otherSettings')}
                        </h2>
                        <p>{trans('subheadings.otherSettings')}</p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans("labels.proformaStartNumber")}
                        </label>

                        <input
                            type="number"
                            name="data[proforma_start_number]"
                            value={popup.data ? popup.data.proforma_start_number : ''}
                            className={validations && validations.proforma_start_number ? 'validate' : ''}
                            onChange={handleInputChange}
                        />

                    </div>
                </div>

                <br />

                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans("labels.invoiceStartNumber")}
                        </label>

                        <input
                            type="number"
                            name="data[invoice_start_number]"
                            value={popup.data ? popup.data.invoice_start_number : ''}
                            className={validations && validations.invoice_start_number ? 'validate' : ''}
                            onChange={handleInputChange}
                        />

                    </div>
                </div>

                <br />

                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans("labels.creditNoteStartNumber")}
                        </label>

                        <input
                            type="number"
                            name="data[credit_note_start_number]"
                            value={popup.data ? popup.data.credit_note_start_number : ''}
                            className={validations && validations.credit_note_start_number ? 'validate' : ''}
                            onChange={handleInputChange}
                        />

                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans("buttons.cancel")}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans("buttons.save")}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Others)